import { common } from './common'
import { nav } from './nav'
import { auth } from './auth'
import { dashboard } from './dashboard'
import { database } from './database'
import { analyser } from './analyser'
import { inbox } from './inbox'
import { poTracking } from './poTracking'
import { settings } from './settings'

// Merged German dictionary (English source string -> German). Area files are
// spread after `common`; area files must not redefine common keys — a duplicate
// key would silently win here depending on the spread order, which is why
// `npm run i18n:check` reports duplicates as an error.
export const DE: Record<string, string> = {
  ...common,
  ...nav,
  ...auth,
  ...dashboard,
  ...database,
  ...analyser,
  ...inbox,
  ...poTracking,
  ...settings,
}
